<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">

                    <header>
                        <figure class="no-radius">
                            <i v-if="!resource.picture" class="icon icon-icon_tags"></i>
                            <img v-if="resource.picture" :src="resource.picture.url+'/fit/100x100'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Product <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>

                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-text :label="'Nom'" v-model="resource.name" :required="true"></form-text>
                                <form-text :label="'Slug'" v-model="resource.slug" :required="true"></form-text>
                                <form-select label="Attributes" multiple="true" v-model="selection" id="id" :options="attributes" v-if="attributes"></form-select>

                                <form-sort :label="'Ordre'" v-model="selection"></form-sort>

                            </tab>
                        </tabs>

                    </main>
                    <footer>
                    </footer>
                </article>

            </div>
        </div>
    </transition>
</template>
<script>

    import ProductTypeService from './ProductTypeService.js';
    import AttributeService from '../../config/attribute/AttributeService.js';
    import Edit from '../../../layouts/Edit.vue';

    export default {
        extends: Edit,
        data () {
            return {
                resource: {
                    attributes: [],
                    addressable: [],
                    user: {
                        scopes: []
                    }
                },
                attributes: [],
                selection: [],
                isLoading: false
            }
        },
        mounted: function(){

        },
        methods:{
            resourceLoaded: function(){

                this.resource.attributes = this.resource.attributes || [];

                if( this.$route.meta.action == "edit" ) {
                    let attributes = [];
                    for (let item of this.resource.attributes) {
                        attributes.push(item.id);
                    }
                    this.resource.attributes = attributes
                }

                AttributeService.allForProducts().then(response => {
                    this.attributes = []
                    this.selection = []
                    this.isLoading = false

                    for(let item of response.data){
                        if( !item.parent_id){
                            this.attributes.push(item);
                        }
                        if( !item.parent_id && this.resource.attributes.indexOf(item.id) >= 0 ){
                            this.selection.push({id:item.id, name:item.name});
                        }
                    }

                })

                this.initialize()
            },
            getResource: function(){
                return ProductTypeService
            },
            beforeUpdate: function(Resource){
                Resource.attributes = this.selection
                return true;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/type/Edit.vue